import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'utils/modifiedTranslation';
import { useIsMobileResolution } from 'utils/hooks/useIsMobileResolution';
import styles from './treatments-guide.module.css';
import ConsultationImg from './assets/images/consultation.svg';
import { ReactComponent as DoctorIcon } from './assets/images/doctor.svg';

export const TreatmentOptionsGuide = ({ onClickShare, onClickTalk, sponsoredUser }) => {
  const isMobileResolution = useIsMobileResolution();
  const { t } = useTranslation();

  return (
    <div className={cx(styles.root, { [styles.sponsored]: sponsoredUser })}>
      <div className={styles.imageWrapper}>
        <img src={ConsultationImg} alt="consultation" />
      </div>
      <div className={styles.contentWrapper}>
        <h2 className={styles.mainTitle}>{t('treatments_guide.title')}</h2>
        <button
          className={cx(styles.button, styles.talkButton)}
          type="button"
          onClick={onClickTalk}
        >
          {t('treatments_guide.button.talk_with_us')}
        </button>
        <div className={styles.divider} />
        <button
          className={cx(
            styles.button,
            styles.shareButton,
            { [styles.outlined]: sponsoredUser },
          )}
          type="button"
          onClick={onClickShare}
        >
          <DoctorIcon />
          {isMobileResolution
            ? t('treatments_guide.button.share.mobile')
            : t('treatments_guide.button.share.desktop')}
        </button>
      </div>
    </div>
  );
};

TreatmentOptionsGuide.propTypes = {
  onClickShare: PropTypes.func.isRequired,
  onClickTalk: PropTypes.func.isRequired,
  sponsoredUser: PropTypes.bool.isRequired,
};
